import React, { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import SearchList, { SearchListWrapper } from '../components/SearchList'
import LabelInput from '../components/LabelInput'
import RowRadioButton from '../components/RowRadioButton'
import LabelOnly from '../components/LabelOnly'
import LabelAutoComplete from '../components/LabelAutoComplete'
import ColumnRadioWith3M from '../components/ColumnRadioWith3M'
import { TitleButton } from '../components/TitleButton'
import { StatusBoardLoad } from '../components/StatusBoardLoad'
import PatternLabelHeader from '../components/PatternLabelHeader'
import PatternSelection from '../components/PatternSelection'
import { useLazyQuery, useMutation, useQuery } from '@apollo/client'
import { KEPCOPlanTypeList } from '../util/KEPCOPlanType'
// import MonthPattern from '../components/MonthPattern' // [제거 또는 주석]
import { customerStatusFunc } from '../util/customerStatusFunc'
import { ISeasonalNum } from '../util/algorithm/algoInterface'
import { divTimeData } from '../util/algorithm/classifyTimeData'
import { calSeasonalSum } from '../util/algorithm/monthToSeason'
import { seasonMapping } from '../util/SeasonMapping'
import { findLatestKepcoTOUPlanGQL } from '../gql/PurchasePlans.gql'
import { KepcoChargeUnitTable } from '../components/KepcoChargeUnitTable'
import { calMonthRepPattern } from '../util/algorithm/calRepPattern'
import MonthLineGraph2 from '../components/graph/MonthLineGraph2'
import {
  CreateLoadcustGQL,
  DeleteLoadcustGQL,
  findAllLoadCustGQL,
  findAllLoadPatternNamesGQL,
  findLoadPatternDataGQL,
  findOneLoadcusGQL,
  UpdateLoadcustGQL,
} from '../gql/CustomerLoad.gql'
import {
  // AddButton, // [제거] 더 이상 필요 없음
  Body,
  BodyWrapper,
  ContentWrapper,
  DetailColWrapper,
  DetailWrapper,
  DivisionWrapper,
  GraphBody,
  GraphWrapper,
  Header,
  Left,
  MonthChip,
  MonthChipText,
  MonthChipWrapper,
  PatternSelectWrapper,
  Right,
  SeasonBox,
  SeasonFrame,
  SeasonTextBox,
  Text,
  TextBox,
  TextBox2,
  TextWrapper,
} from '../style/CustomerLoad.styled'

export interface ICustomerLoadData {
  name: string
  custType: string
  KEPCOPlanType: { _id: string; name: string } | null
  prevKEPCOContractedPower: number
  re100Opt: string
  loadOpt: string
  patternList: any[]
  _id?: string
  index?: string
}

export const initializecustomerLoadData = (): ICustomerLoadData => {
  return {
    name: '',
    custType: 'Large',
    KEPCOPlanType: null,
    prevKEPCOContractedPower: 0,
    re100Opt: 'notAchieve',
    loadOpt: 'realTime',
    patternList: [
      { patternId: '', months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] },
    ],
  }
}

const KepcoPlanRateTitle = styled.div`
  font-family: SUIT;
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
  color: #2f3c5e;
`

const KepcoPlanRateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const PatternHeaderWrapper = styled.div`
  width: 100%;
`

export const CustomerLoad = () => {
  const [LoadData, setLoadData] = useState<ICustomerLoadData>(
    initializecustomerLoadData
  )

  const [findOneLoadData, { data: queryData, refetch, loading, error }] =
    useLazyQuery(findOneLoadcusGQL, { fetchPolicy: 'network-only' })

  const { data: LoadPatternListData } = useQuery(findAllLoadPatternNamesGQL)
  const [LoadPatternList, setLoadPatternList] = useState<any>()
  const kepcoPlanName = LoadData.KEPCOPlanType?.name || ''
  const { data: latestKepcoPlanData } = useQuery(findLatestKepcoTOUPlanGQL, {
    variables: { planName: kepcoPlanName },
    skip: !kepcoPlanName,
    fetchPolicy: 'network-only',
  })
  const [createLoadcust] = useMutation(CreateLoadcustGQL)
  const [updateLoadcust] = useMutation(UpdateLoadcustGQL)
  const [deleteLoadcust] = useMutation(DeleteLoadcustGQL)
  const [isModify, setIsModify] = useState(false)
  const [radioValue, setRadioValue] = useState('0')
  const [re100OptRadioValue, setRe100OptRadioValue] = useState('1')
  const [loadOptRadio, setLoadOptRadio] = useState('0')
  const [selectedPatternId, setSelectedPatternId] = useState('')
  const [selectedMonths, setSelectedMonths] = useState<number[]>([1])
  const [loadGraph, setLoadGraph] = useState<any>([])
  const [kEPCOPlanTypeList, setKEPCOPlanTypeList] = useState<any>()

  const [findPatternData] = useLazyQuery(findLoadPatternDataGQL)
  const [PatternData, setPatternData] = useState<any>()
  const activePattern = LoadData.patternList?.[0]
  const activePatternId = activePattern?.patternId || ''
  const activePatternMonthsKey =
    activePattern?.months && activePattern.months.length > 0
      ? activePattern.months.join(',')
      : '1,2,3,4,5,6,7,8,9,10,11,12'
  const [seasonSum, setSeasonSum] = useState<ISeasonalNum>({
    spr: 0,
    sum: 0,
    fall: 0,
    win: 0,
  })

  const [listRefetch, setListRefetch] = useState<() => void>(() => () => {})
  const latestKepcoPlan = latestKepcoPlanData?.findLatestKepcoTOUPlan
  const shouldShowLatestKepcoPlan =
    kepcoPlanName && latestKepcoPlan?.data?.name === kepcoPlanName

  const handleRefetch = useCallback(() => {
    if (listRefetch) {
      listRefetch()
    }
  }, [listRefetch])

  // [수정] 데이터 로드 로직 (단일 패턴 강제 및 깊은 복사)
  useEffect(() => {
    let sourceData = null

    if (queryData) {
      if (queryData.findOneLoadCust) {
        sourceData = queryData.findOneLoadCust
      } else if (queryData.findOneLoadcus) {
        sourceData = queryData.findOneLoadcus
      }
    }

    if (sourceData) {
      const loadedData: ICustomerLoadData = JSON.parse(
        JSON.stringify(sourceData)
      )

      loadedData.re100Opt = loadedData.re100Opt ?? 'notAchieve'
      loadedData.loadOpt = loadedData.loadOpt ?? 'realTime'

      if ('__typename' in loadedData) {
        delete (loadedData as any).__typename
      }

      // 단일 패턴 강제
      if (!loadedData.patternList || loadedData.patternList.length === 0) {
        loadedData.patternList = [
          { patternId: '', months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] },
        ]
      } else if (loadedData.patternList.length > 1) {
        loadedData.patternList = [
          {
            patternId: loadedData.patternList[0].patternId,
            months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
          },
        ]
      } else {
        loadedData.patternList[0].months = [
          1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12,
        ]
      }

      setLoadData(loadedData)
    }
  }, [queryData])

  useEffect(() => {
    if (LoadData.custType === 'Large') {
      setKEPCOPlanTypeList(
        KEPCOPlanTypeList.filter((v) => !v.name.includes('전기차'))
      )
    } else if (LoadData.custType === 'EV') {
      setKEPCOPlanTypeList(
        KEPCOPlanTypeList.filter((v) => v.name.includes('전기차'))
      )
    }
  }, [LoadData.custType])

  useEffect(() => {
    if (PatternData) {
      const div1000 = divTimeData(PatternData, 1000)
      setSeasonSum(calSeasonalSum(div1000, seasonMapping))
    }
  }, [PatternData])

  useEffect(() => {
    setSelectedPatternId(LoadData.patternList?.[0]?.patternId || '')
  }, [LoadData.patternList])

  useEffect(() => {
    if (!PatternData) {
      setLoadGraph([])
      return
    }

    const tmpData = divTimeData(PatternData, 1000)

    switch (LoadData.loadOpt) {
      case 'aver':
        setLoadGraph(calMonthRepPattern(tmpData, 'aver').graphData)
        break

      case 'mid':
        setLoadGraph(calMonthRepPattern(tmpData, 'mid').graphData)
        break

      case 'mode':
        setLoadGraph(calMonthRepPattern(tmpData, 'mode').graphData)
        break

      case 'realTime':
      default:
        setLoadGraph(tmpData)
        break
    }
  }, [LoadData.loadOpt, PatternData])

  useEffect(() => {
    handleResetAll()
  }, [])

  const handleResetAll = () => {
    setLoadData(initializecustomerLoadData())
    setPatternData(undefined)
    setSeasonSum({
      spr: 0,
      sum: 0,
      fall: 0,
      win: 0,
    })
  }

  const handleFindOne = (id: string) => {
    findOneLoadData({ variables: { val: id } })
  }

  useEffect(() => {
    if (!activePatternId) {
      setPatternData(undefined)
      return
    }

    customerStatusFunc(
      [
        {
          patternId: activePatternId,
          months: activePatternMonthsKey.split(',').map(Number),
        },
      ],
      findPatternData,
      'load'
    ).then((result) => {
      setPatternData(result)
    })
  }, [activePatternId, activePatternMonthsKey, findPatternData])

  useEffect(() => {
    setIsModify(!!LoadData._id)
  }, [LoadData._id])

  useEffect(() => {
    if (LoadPatternListData) {
      const newData = LoadPatternListData.findAllCustomerAPINames?.map(
        (item: any) => ({
          value: item.name,
          label: item.name,
        })
      )
      setLoadPatternList(newData)
    }
  }, [LoadPatternListData])

  useEffect(() => {
    switch (LoadData.custType) {
      case 'EV':
        setRadioValue('1')
        break

      case 'Large':
      default:
        setRadioValue('0')
        break
    }
  }, [LoadData.custType])

  useEffect(() => {
    setRe100OptRadioValue(LoadData.re100Opt === 'achieve' ? '0' : '1')
  }, [LoadData.re100Opt])

  useEffect(() => {
    switch (LoadData.loadOpt) {
      case 'realTime':
        setLoadOptRadio('0')
        break

      default:
        setLoadOptRadio('1')
        break
    }
  }, [LoadData.loadOpt])

  // [수정] addPattern, removePattern 함수는 이제 필요 없으므로 제거해도 됨
  // (단일 패턴이라 추가/삭제 개념이 사라짐)

  const handleDataChange = (key: string, newValue: number | string) => {
    setLoadData((prev) => {
      const updatedDataUnit = { ...prev, [key]: newValue }
      return updatedDataUnit
    })
  }

  const handleRadiobutton = (value: string) => {
    switch (value) {
      case '1':
        setLoadData((prev) => {
          return { ...prev, custType: 'EV' }
        })
        break

      case '0':
      default:
        setLoadData((prev) => {
          return { ...prev, custType: 'Large' }
        })
        break
    }
  }

  const handleRe100OptRadiobutton = (value: string) => {
    setLoadData((prev) => ({
      ...prev,
      re100Opt: value === '0' ? 'achieve' : 'notAchieve',
    }))
  }

  const handleLoadOptRadiobutton = (value: string) => {
    setLoadData((prev) => ({
      ...prev,
      loadOpt: value === '0' ? 'realTime' : 'aver',
    }))
  }

  const toggleMonth = (month: number) => {
    setSelectedMonths([month])
  }

  const onSave = async () => {
    // @ts-ignore
    const { KEPCOPlanType, __typename, ...less } = LoadData
    const patternList =
      less.patternList && less.patternList.length > 0
        ? less.patternList.map((pattern: any) => ({
            ...pattern,
            months:
              pattern.months && pattern.months.length > 0
                ? pattern.months
                : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
          }))
        : [
            {
              patternId: '',
              months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            },
          ]

    try {
      if (LoadData._id) {
        // [UPDATE] await 필수
        await updateLoadcust({
          variables: {
            val: {
              ...less,
              patternList,
              KEPCOPlanType: KEPCOPlanType,
            },
          },
        })
      } else {
        // [CREATE] await 필수
        await createLoadcust({
          variables: {
            val: {
              ...less,
              patternList,
              KEPCOPlanType: KEPCOPlanType,
            },
          },
        })
      }

      // 데이터 갱신
      refetch()
      handleRefetch()
    } catch (e) {
      console.error(e)
      alert('저장 중 오류 발생')
      throw e
    }
  }

  const onDelete = async () => {
    if (LoadData._id) {
      try {
        await deleteLoadcust({
          variables: {
            val: LoadData._id,
          },
        })
        listRefetch()
        handleResetAll()
      } catch (e) {
        console.error(e)
        alert('삭제 오류')
      }
    }
  }

  return (
    <>
      <SearchListWrapper>
        <SearchList
          onReset={handleResetAll}
          findOne={findOneLoadData}
          findAllListgql={findAllLoadCustGQL}
          setRefetch={setListRefetch}
          nameKey="name"
          descriptionRenderer={(item: ICustomerLoadData) =>
            `${Number(item.prevKEPCOContractedPower ?? 0).toLocaleString()}kW`
          }
        />
      </SearchListWrapper>
      <ContentWrapper>
        <Header>
          <TitleButton
            title="수용가 정보"
            onSaveClick={onSave}
            onCancleClick={handleResetAll}
            onDeleteClick={onDelete}
            isModify={isModify}
          />
          {/* <StatusBoardLoad name={LoadData?.name} seasonSum={seasonSum} /> */}
        </Header>
        <BodyWrapper>
          <Body>
            <Left>
              <LabelInput
                label="고객명"
                placeholder="이름을 입력하세요"
                onChange={(e) => handleDataChange('name', e.target.value)}
                value={LoadData.name}
              />
              <DivisionWrapper>
                <LabelOnly label="구분" />
                <RowRadioButton
                  list={[{ label: '수용가' }, { label: 'EV충전소' }]}
                  onChange={(value: string) => handleRadiobutton(value)}
                  value={radioValue}
                />
              </DivisionWrapper>
              <DivisionWrapper>
                <LabelOnly label="RE100 필요 여부" />
                <RowRadioButton
                  list={[{ label: '필요' }, { label: '해당 없음' }]}
                  onChange={(value: string) => handleRe100OptRadiobutton(value)}
                  value={re100OptRadioValue}
                />
              </DivisionWrapper>
              <LabelAutoComplete
                width={250}
                inputWidth={250}
                label="이용중인 한전 TOU 요금제"
                options={kEPCOPlanTypeList}
                value={LoadData.KEPCOPlanType}
                setData={setLoadData}
                fieldName="KEPCOPlanType"
              />
              <LabelInput
                label="기존 한전과의 계약 전력"
                placeholder="kWh"
                value={LoadData.prevKEPCOContractedPower.toString()}
                onChange={(e) =>
                  handleDataChange(
                    'prevKEPCOContractedPower',
                    Number(e.target.value)
                  )
                }
                type="number"
                unit="kW"
              />
              {shouldShowLatestKepcoPlan && (
                <KepcoPlanRateWrapper>
                  <KepcoPlanRateTitle>
                    {`${latestKepcoPlan.effectiveDateText} 시행 기준 ${latestKepcoPlan.data.name} 단가`}
                  </KepcoPlanRateTitle>
                  <KepcoChargeUnitTable data={latestKepcoPlan.data} />
                </KepcoPlanRateWrapper>
              )}
            </Left>
            <Right>
              <PatternHeaderWrapper>
                <PatternLabelHeader
                  label="수요량 패턴"
                  to="/home/data-electricity"
                />
              </PatternHeaderWrapper>

              <PatternSelection
                title="수요량 패턴 선택"
                list={LoadPatternList}
                index={0}
                value={selectedPatternId}
                data={LoadData}
                setData={setLoadData}
                selectedValue={selectedPatternId}
                setSelectedValue={setSelectedPatternId}
              />
              <DetailColWrapper>
                <DetailWrapper $direction="column">
                  <PatternSelectWrapper>
                    <ColumnRadioWith3M
                      list={[
                        {
                          label: '원본데이터 사용',
                        },
                        {
                          label: '월별 대표 패턴 산정',
                        },
                      ]}
                      onChange={(value: string) =>
                        handleLoadOptRadiobutton(value)
                      }
                      value={loadOptRadio}
                      setRadioValue={setLoadOptRadio}
                      patternData={LoadData.loadOpt}
                      keyName={'loadOpt'}
                      setData={setLoadData}
                    />
                  </PatternSelectWrapper>
                  <GraphWrapper height="auto" width="100%">
                    <MonthChipWrapper>
                      {Array.from({ length: 12 }, (_, index) => (
                        <MonthChip
                          key={index + 1}
                          selected={selectedMonths.includes(index + 1)}
                          onClick={() => toggleMonth(index + 1)}
                        >
                          <MonthChipText>{`${index + 1}월`}</MonthChipText>
                        </MonthChip>
                      ))}
                    </MonthChipWrapper>
                    <GraphBody>
                      <MonthLineGraph2
                        month={selectedMonths[0]}
                        data={loadGraph ? loadGraph : []}
                        width="100%"
                        height="300px"
                        selectedChartDataType={LoadData.loadOpt}
                      />
                    </GraphBody>
                    <TextWrapper $align="center">
                      <Text>연간 수요량</Text>
                      <TextBox>
                        <Text fontColor="#57C9A7" fontSize="20px">
                          총
                        </Text>
                        <TextBox2>
                          <Text
                            fontColor="#57C9A7"
                            fontSize="22px"
                            fontWeight="600"
                          >
                            {Number(
                              (
                                seasonSum.spr +
                                seasonSum.sum +
                                seasonSum.fall +
                                seasonSum.win
                              ).toFixed(0)
                            ).toLocaleString()}
                          </Text>
                          <Text fontColor="#57C9A7" fontSize="18px">
                            kWh
                          </Text>
                        </TextBox2>
                      </TextBox>
                    </TextWrapper>
                    <SeasonFrame>
                      <SeasonBox>
                        <Text fontColor="#666" fontWeight="500">
                          봄
                        </Text>
                        <SeasonTextBox>
                          <Text
                            fontColor="#4D4D4D"
                            fontSize="14px"
                            fontWeight="600"
                          >
                            {Number(seasonSum.spr.toFixed(0)).toLocaleString()}
                          </Text>
                          <Text fontColor="#666" fontWeight="500">
                            kWh
                          </Text>
                        </SeasonTextBox>
                      </SeasonBox>
                      <SeasonBox>
                        <Text fontColor="#666" fontWeight="500">
                          여름
                        </Text>
                        <SeasonTextBox>
                          <Text
                            fontColor="#4D4D4D"
                            fontSize="14px"
                            fontWeight="600"
                          >
                            {Number(seasonSum.sum.toFixed(0)).toLocaleString()}
                          </Text>
                          <Text fontColor="#666" fontWeight="500">
                            kWh
                          </Text>
                        </SeasonTextBox>
                      </SeasonBox>
                      <SeasonBox>
                        <Text fontColor="#666" fontWeight="500">
                          가을
                        </Text>
                        <SeasonTextBox>
                          <Text
                            fontColor="#4D4D4D"
                            fontSize="14px"
                            fontWeight="600"
                          >
                            {Number(seasonSum.fall.toFixed(0)).toLocaleString()}
                          </Text>
                          <Text fontColor="#666" fontWeight="500">
                            kWh
                          </Text>
                        </SeasonTextBox>
                      </SeasonBox>
                      <SeasonBox>
                        <Text fontColor="#666" fontWeight="500">
                          겨울
                        </Text>
                        <SeasonTextBox>
                          <Text
                            fontColor="#4D4D4D"
                            fontSize="14px"
                            fontWeight="600"
                          >
                            {Number(seasonSum.win.toFixed(0)).toLocaleString()}
                          </Text>
                          <Text fontColor="#666" fontWeight="500">
                            kWh
                          </Text>
                        </SeasonTextBox>
                      </SeasonBox>
                    </SeasonFrame>
                  </GraphWrapper>
                </DetailWrapper>
              </DetailColWrapper>
            </Right>
          </Body>
        </BodyWrapper>
      </ContentWrapper>
    </>
  )
}
